/* eslint-disable */
// Ambient background colour for the icon-only hero fallback (see DiscordServerCard).
// Cheap average-colour sampling via an offscreen canvas; Discord's CDN sends
// Access-Control-Allow-Origin: *, so crossOrigin="anonymous" avoids a tainted canvas.
const cache = new Map(); // url -> "r,g,b" | null (null = extraction failed)
const pending = new Map(); // url -> Promise<string>

// Muted Discord blurple: used whenever extraction fails so the fallback never
// regresses to something worse than the old blurred icon.
export const ICON_FALLBACK_RGB = "71,82,196";

function averageColorFromImage(img) {
  const size = 16; // a coarse sample is plenty for an ambient wash
  const canvas = document.createElement("canvas");
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext("2d", { willReadFrequently: true });
  ctx.drawImage(img, 0, 0, size, size);
  const { data } = ctx.getImageData(0, 0, size, size);

  let r = 0, g = 0, b = 0, n = 0;
  for (let i = 0; i < data.length; i += 4) {
    if (data[i + 3] < 24) continue; // skip near-transparent pixels
    r += data[i];
    g += data[i + 1];
    b += data[i + 2];
    n++;
  }
  return n ? `${Math.round(r / n)},${Math.round(g / n)},${Math.round(b / n)}` : null;
}

export function getIconAmbientColor(url) {
  if (!url) return Promise.resolve(ICON_FALLBACK_RGB);
  if (cache.has(url)) return Promise.resolve(cache.get(url) || ICON_FALLBACK_RGB);
  if (pending.has(url)) return pending.get(url);

  const promise = new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      let rgb = null;
      try {
        rgb = averageColorFromImage(img);
      } catch {
        rgb = null; // tainted canvas or unsupported; caller uses the fallback
      }
      cache.set(url, rgb);
      pending.delete(url);
      resolve(rgb || ICON_FALLBACK_RGB);
    };
    img.onerror = () => {
      cache.set(url, null);
      pending.delete(url);
      resolve(ICON_FALLBACK_RGB);
    };
    img.src = url;
  });

  pending.set(url, promise);
  return promise;
}
